// extracted by mini-css-extract-plugin
module.exports = {"side":"style_side__16e5N","outer":"style_outer__arMS0","inner":"style_inner__36UmW","drag-bar":"style_drag-bar__2ryf-","drag-bar-icon":"style_drag-bar-icon__2jFxa"};